import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import AdminLayout from '../layout/AdminLayout';
import AdminRoutes from './AdminRoutes';
import AccountLogin from "../pages/accounts/login";

const Router = () => {
    
    return (
        <>
            <Routes>
                <Route path="/" element={<AccountLogin />}></Route>
                <Route path="" element={<Outlet />} >
                    {
                        AdminRoutes.map((element) => {
                            return (
                                <Route key={element} path={element.path} element={<AdminLayout component={element.component} />} />
                            );
                        })
                    }
                </Route>
                <Route exact path="*" element={<h1>Not Found</h1>} />
            </Routes>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default React.memo(Router);